// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseHomeHealthAgencyRelationshipModel {
    static getAttributeTypeMap() {
        return CaseHomeHealthAgencyRelationshipModel.attributeTypeMap;
    }
}
CaseHomeHealthAgencyRelationshipModel.discriminator = undefined;
CaseHomeHealthAgencyRelationshipModel.additionalProperties = false;
CaseHomeHealthAgencyRelationshipModel.attributeTypeMap = [
    {
        "name": "homeHealthAgencyId",
        "baseName": "homeHealthAgencyId",
        "type": "number"
    },
];
//# sourceMappingURL=caseHomeHealthAgencyRelationshipModel.js.map